// extracted by mini-css-extract-plugin
export default {"clients":"Clients_clients__bvcp6","client":"Clients_client__S5QQQ","allClients":"Clients_allClients__XlZrk"};